import { Stack } from "@mui/material";
import { LabeledAll } from "./labeledAll";
import { withErrorBoundaryManyInstance } from "./errorBoundary";
import { useMyContext } from "./myContext";
import { onlyExistentFields } from "../acl/existentFields";
import { useResourceContext } from "react-admin";

export const LabeledColumn = ({ children, sx }) => {
  const resource = useResourceContext();
  const {
    forcedCustomFields,
    removedCustomFields,
    permissionsShowAction = "show",
  } = useMyContext();

  children = onlyExistentFields(
    children,
    resource,
    permissionsShowAction,
    forcedCustomFields,
    removedCustomFields
  );

  return (
    <Stack direction="column" sx={sx}>
      <LabeledAll>{withErrorBoundaryManyInstance(children)}</LabeledAll>
    </Stack>
  );
};
